<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
  
  	  <div class="backborder1">   
	      <!------------------------search---------------------->
	      <el-form :inline="true" class="demo-form-inline" style="margin-top:15px" size="small">
		  		<el-form-item style="width:19%">
		            <el-date-picker
		                v-model="query.date"
		                type="daterange"
		                range-separator="至"
		                start-placeholder="开始日期"
		                end-placeholder="结束日期"
						unlink-panels="true"
		                value-format="yyyy-MM-dd" @change="query.ischange=true" clearable style="width:100%">
		            </el-date-picker>
	            </el-form-item>
	            <el-form-item style="width:9%">
		            <el-select v-model="query.clerkid" clearable filterable placeholder="全部销售员" @change="query.ischange=true" style="width:100%">
		                <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
		            </el-select> 
	            </el-form-item>
	            <el-form-item style="width:12%">
					<el-select v-model="query.brandid" clearable filterable placeholder="按品牌" @change="query.ischange=true">
						<el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.brandid" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item size="small" style="width:15%">
					<el-select v-model="query.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" @change="query.ischange=true" style="width:100%">
						<el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
					</el-select> 
    			</el-form-item>
	            <el-form-item style="width:12%;">
	            	<el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
	            	<el-button type="success" @click="outputinfos">导出</el-button>
	            </el-form-item>
	        </el-form>
        </div>
        <!------------------------search end---------------------->

		<el-tag type="danger" style="margin-top:10px">注：该处统计的信息为线下销售出库单（已完成状态）的下单客户数据（散客不统计），按照品牌分组</el-tag>
		
		<div class="backborder2" style="margin-top:10px">
	        <el-table :data="lists" v-loading="query.loading">
	            <el-table-column label="销售员" prop="clerkname"></el-table-column>
	          	<el-table-column label="品牌" prop="brandname" width="200" align="center"></el-table-column>
				<el-table-column label="客户名称" prop="customername" width="200" align="center"></el-table-column>
				<el-table-column label="客户电话" prop="phone" width="200" align="center"></el-table-column>
				<el-table-column label="客户地址" prop="address" width="200" align="center"></el-table-column>
				<el-table-column label="销售金额" prop="totals" width="200" align="center"></el-table-column>
	        </el-table>
	        <div class="block">
	        <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	        </div>
        </div>

		<!-- 导出数据 -->
		<el-dialog title="导出客户销售信息确认" :visible.sync="clerksellDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="clerkstatoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="clerksalelists" border v-loading="clerkLoading">
		      	  	<el-table-column prop="clerkname" label="销售员名称"></el-table-column>
					<el-table-column prop="brandname" label="品牌名称" align="center"></el-table-column>
					<el-table-column prop="customername" label="客户名称" align="center"></el-table-column>
					<el-table-column prop="phone" label="客户电话" align="center"></el-table-column>
					<el-table-column prop="address" label="客户地址" align="center"></el-table-column>
					<el-table-column prop="cityname" label="客户所属城市" align="center"></el-table-column>
					<el-table-column prop="district_name" label="客户所属区域" align="center"></el-table-column>
					<el-table-column prop="totals" label="销售金额" align="center"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="clerksellDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="clerkstatoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>

             
  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //功能操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Stat/index",
      lists:[],
      query:{
        act:'getsalecustomersfromclerk',
        token:this.$cookies.get('token'),
        date:[new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate()],
        clerkid:'',
        brandid:'',
		customerid:'',
        loading:false,
		ischange:false,
		rollpage: 10, // 页大小
        p: 1,
      },
      total_rows:0,
	  sellerLists:[],
	  customerLoading:false,
	  brandlists:[],
	  clerksellDialog:false,
	  clerkLoading:false,
	  clerksalelists:[],
	  customerLists:[],
	  customerLoading:false,
      
    }
  },
  mounted(){
	this.getactionauth();
    this.getSeller(); //获取销售员信息
	this.getBrand(); //获取品牌信息表
    this.getList(); //获取信息列表
  },
  methods:{
  
  	/** 获取功能权限  **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
  
    //信息列表
    getList(){
      if(this.query.ischange==true) {
		  this.query.p=1;
		  this.query.rollpage=10;	    	
      }

      this.query.loading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.query.loading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows=parseInt(res.data.count);
          this.query.loading = false;
		  if(this.query.ischange==true) this.query.ischange=false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.query.loading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },


	/** 导出数据 **/
	outputinfos() {
		this.clerksellDialog=true;
		this.clerkLoading=true;
	    var resource = this.$resource(this.GLOBAL.exportUrl+"Stat/index");
	    resource.query({act:'getsalecustomersfromclerkmore',token:this.$cookies.get('token'),date:this.query.date,clerkid:this.query.clerkid,brandid:this.query.brandid,customerid:this.query.customerid}).then((res) => {
	        if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.clerkLoading=false;
	        }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
		        this.clerksalelists=result;
		        this.clerkLoading=false;
	        }
	    }).catch((res) => {
	        this.clerkLoading=false;
	    });
	},




    //获取销售员
    getSeller(){
      var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        }else{
          this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    

	/** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },


	/** 获取客户 **/
    getCustomer(query){
        if (query !== '') {
	        this.customerLoading = true;
	        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	        resource.query({act:'lists',key:query,token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.customerLoading = false;
	            }else{
		            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
		            this.customerLoading = false;
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	            this.customerLoading = false;
	        });
        }
    },
    
    
    /** 确认导出订单信息 **/
    clerkstatoutput() {
		require.ensure([], () => {
			var { export_json_to_excel } = require('../../vendor/Export2Excel');
			var tHeader = ['销售员','品牌名称','下单客户','客户电话','客户地址','客户所属城市','客户所属区域','下单金额'];
			var filterVal = ['clerkname','brandname','customername','phone','address','cityname','district_name','totals'];
				
			var list = this.clerksalelists;
			var data = this.formatJson(filterVal, list);
			export_json_to_excel(tHeader, data, '销售员品牌销售客户数');
			this.clerksellDialog=false;
		})
    },
    
    //导出表格数据
	formatJson(filterVal, jsonData) {
　　　　return jsonData.map(v => filterVal.map(j => v[j]));
　　},
    
  }
}
</script>

<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/stat/StatSaletoCustomer.vue